export default __webpack_public_path__ + "7954434d5c7157f0a2adecb1dc096aa2.png";